import { FC } from "react";

import { useUrlMappingEditPageParams } from "~/src/routes/hooks";

import { UrlMappingEditFormContainer } from "../../features/settings/UrlMappingForm";

import { UrlMappingEditPage } from "./presentations";

export const UrlMappingEditPageContainer: FC = () => {
  const { siteSlug, urlMappingId } = useUrlMappingEditPageParams();

  return (
    <UrlMappingEditPage siteSlug={siteSlug} urlMappingId={urlMappingId}>
      <UrlMappingEditFormContainer
        siteSlug={siteSlug}
        urlMappingId={urlMappingId}
      />
    </UrlMappingEditPage>
  );
};
